"use client";

import { useState, useEffect } from "react";

import {
  AdminIcon,
  CloseIcon,
  CloudinaryIcon,
  VercelIcon,
  GoogleDriveIcon,
  FigmaIcon,
  GithubIcon,
  TinaIcon,
  ResendIcon,
  CalIcon,
} from "@/assets";
import { cn } from "@/lib/utils";

import { EditProvider, useEditState } from "@tinacms/sharedctx";

const AdminSidebar = () => {
  return (
    <EditProvider>
      <AdminSidebarInner />
    </EditProvider>
  );
};

export const useIsEditing = () => {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const isInIframe = window.self !== window.top;
      setIsEditing(isInIframe);
    }
  }, []);

  return isEditing;
};

const AdminSidebarInner = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  // const { edit } = useEditState();
  const isEditing = useIsEditing();

  const showAdminSidebar = isEditing;

  if (!showAdminSidebar) return null;

  return (
    <>
      <div
        className={cn(
          "admin-dashboard fixed top-6 right-0 bg-[#0084ff] hover:bg-[#0474e4] z-[60] rounded-l-full cursor-pointer h-10 w-[56px] flex justify-center items-center"
        )}
        onClick={() => setDrawerOpen(!drawerOpen)}
      >
        {drawerOpen ? (
          <CloseIcon className="w-6 h-6 text-white ml-1" />
        ) : (
          <AdminIcon className="w-7 h-7 text-white ml-1" />
        )}
      </div>
      <div
        className={cn(
          "fixed top-0 -right-1 h-screen z-base bg-white z-50 shadow-sm border-l border-gray-100 "
        )}
      >
        <div
          className={cn(
            "relative h-screen transform flex transition-all duration-300 ease-out overflow-hidden",
            drawerOpen ? "max-w-[450px] z-50" : "max-w-[1px]"
          )}
        >
          <div className="p-8 min-w-[450px] overflow-hidden flex flex-col gap-6 divide-y divide-black/10">
            <div className="flex-[2] space-y-4 overflow-auto">
              <div className="font-semibold text-xl select-none text-black">
                Resources
              </div>
              <div className="space-y-3">
                <ResourceLink
                  icon={GoogleDriveIcon}
                  iconClassName="w-9 h-9"
                  title="Resources"
                  subtitle="View all project files"
                  href="https://drive.google.com/drive/folders/1ZlaAnP8aHt3YLsK7KbI42qz2yNn5eE-i?usp=sharing"
                />
                <ResourceLink
                  icon={FigmaIcon}
                  iconClassName="w-9 h-9"
                  title="Designs"
                  subtitle="View the website mockups in Figma"
                  href="https://www.figma.com/design/9aBXb1stfhqyCFRo3Scing/INT-Aberrant?node-id=12187-423&t=5c1JQzc8ClDx2XzL-0"
                />
                <ResourceLink
                  icon={VercelIcon}
                  iconClassName="w-9 h-9"
                  title="Analytics"
                  subtitle="View the analytics for the website"
                  href="https://vercel.com/comedia/aberrant-website/analytics"
                />
                <ResourceLink
                  icon={TinaIcon}
                  iconClassName="w-9 h-9"
                  title="CMS"
                  subtitle="TinaCMS"
                  href="https://app.tina.io"
                />
                <ResourceLink
                  icon={CalIcon}
                  iconClassName="w-9 h-9"
                  title="Cal.com (Book Demo Form)"
                  subtitle="View the booking form for the website"
                  href="https://app.cal.com/event-types"
                />
                <ResourceLink
                  icon={ResendIcon}
                  iconClassName="w-9 h-9"
                  title="Emails (Contact Form)"
                  subtitle="View the emails for the website"
                  href="https://resend.com/emails"
                />
                <ResourceLink
                  icon={CloudinaryIcon}
                  iconClassName="w-9 h-9"
                  title="Image Hosting (Cloudinary)"
                  subtitle="View the images for the website"
                  href="https://console.cloudinary.com"
                />
                <ResourceLink
                  icon={VercelIcon}
                  iconClassName="w-9 h-9"
                  title="Hosting (Vercel)"
                  subtitle="Hosting for the website"
                  href="https://vercel.com/comedia/aberrant-website"
                />
                <ResourceLink
                  icon={GithubIcon}
                  iconClassName="w-9 h-9"
                  title="Repo (GitHub)"
                  subtitle="View the repo for the website"
                  href="https://github.com/comediadesign/aberrant-website"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <VercelToolbar /> */}
    </>
  );
};

export default AdminSidebar;

const ResourceLink = ({
  title,
  subtitle,
  icon: Icon,
  iconClassName = "w-7 h-7",
  href = "",
}) => {
  return (
    <a
      className="border border-gray-300 flex items-center gap-3 px-3 py-3 rounded cursor-pointer hover:bg-gray-100/40"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="w-12 h-12 flex items-center justify-center">
        <Icon className={iconClassName} />
      </div>
      <div className="space-y-0.5">
        <div className="font-semibold text-black">{title}</div>
        <div className="text-gray-500 text-sm">{subtitle}</div>
      </div>
    </a>
  );
};
